import { node } from 'prop-types';
import React from 'react';

// Workaround to make Pusher work with SSR
function PusherProvider({ children }) {
  return typeof window !== `undefined` ? (
    (() => {
      // eslint-disable-next-line global-require
      const Pusher = require('@seaweb/coral/components/Pusher').default;
      return <Pusher>{children}</Pusher>;
    })()
  ) : (
    <div data-coral-pusher-queue-position="middle-center">{children}</div>
  );
}

PusherProvider.propTypes = {
  children: node,
};

export default PusherProvider;
